import { useState } from "react";

interface Props {
  className?: string;
  enableHover?: boolean;
  hoverDuration?: number;
}

export const _FooterTiktokIcon = ({
  className = "",
  enableHover = true,
  hoverDuration = 200
}: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href="https://www.tiktok.com/@foreveryoursfilms"
      target="_blank"
      rel="noopener noreferrer"
      className={`relative w-[42px] h-[42px] ${className}`}
      onMouseEnter={() => enableHover && window.innerWidth >= 768 && setIsHovered(true)}
      onMouseLeave={() => enableHover && window.innerWidth >= 768 && setIsHovered(false)}
    >
      {/* Default state */}
      <svg
        className={`absolute inset-0 transition-opacity duration-${hoverDuration}`}
        style={{ opacity: isHovered && window.innerWidth >= 768 ? 0 : 1 }}
        fill="none"
        height="43"
        viewBox="0 0 43 43"
        width="43"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21.2969" cy="21.6641" r="21" stroke="var(--fy-grey)" strokeWidth="1" fill="none" />
        <path
          d="M28.3574 16.7305V19.6587C26.8266 19.6587 25.4062 19.1736 24.2478 18.3533V24.2756C24.2478 26.3606 23.0432 28.1739 21.2864 29.0678C20.5415 29.4462 19.6965 29.6621 18.8026 29.6621C15.8001 29.6621 13.3574 27.247 13.3574 24.2756C13.3574 21.3043 15.8001 18.8892 18.8026 18.8892C19.0543 18.8892 19.3035 18.907 19.5475 18.94V21.9316C19.3112 21.858 19.062 21.8199 18.8026 21.8199C17.4311 21.8199 16.3189 22.9195 16.3189 24.2782C16.3189 25.6369 17.4311 26.734 18.8026 26.734C20.1742 26.734 21.2864 25.6343 21.2864 24.2782V12.6621H24.2478C24.2478 14.9096 26.0869 16.7305 28.3574 16.7305Z"
          fill="var(--fy-grey)"
        />
      </svg>

      {/* Hover state */}
      <svg
        className={`absolute inset-0 transition-opacity duration-${hoverDuration}`}
        style={{ opacity: isHovered && window.innerWidth >= 768 ? 1 : 0 }}
        fill="none"
        height="43"
        viewBox="0 0 43 43"
        width="43"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21.2969" cy="21.6641" r="21" fill="var(--fy-grey)" />
        <path
          d="M28.3574 16.7305V19.6587C26.8266 19.6587 25.4062 19.1736 24.2478 18.3533V24.2756C24.2478 26.3606 23.0432 28.1739 21.2864 29.0678C20.5415 29.4462 19.6965 29.6621 18.8026 29.6621C15.8001 29.6621 13.3574 27.247 13.3574 24.2756C13.3574 21.3043 15.8001 18.8892 18.8026 18.8892C19.0543 18.8892 19.3035 18.907 19.5475 18.94V21.9316C19.3112 21.858 19.062 21.8199 18.8026 21.8199C17.4311 21.8199 16.3189 22.9195 16.3189 24.2782C16.3189 25.6369 17.4311 26.734 18.8026 26.734C20.1742 26.734 21.2864 25.6343 21.2864 24.2782V12.6621H24.2478C24.2478 14.9096 26.0869 16.7305 28.3574 16.7305Z"
          fill="var(--fy-blue)"
        />
      </svg>
    </a>
  );
}; 